import React, { useState, useRef } from "react";
import { Form, Col, Row, Radio, Modal, Button, message, Select } from "antd";
import PersianDatePicker from "../../components/PersianDatePicker";
import ListPage from "../../components/Page/listPage";

import "./index.css";
import { useEffect } from "react";
import Widget from "../../components/Widget";
import LoadingButton from "../../components/general/Button/Loading";
import CircularProgress from "../../components/CircularProgress";
import { ReadReport } from "../../API/SalesAnalysis";
import { getAllMarketers } from "../../API/Map/marketerLocation";

const RadioGroup = Radio.Group;

export default function SalesAnalysis() {
  const [opneModal, setModalOpen] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [tableType, setTableType] = useState({ target: { value: 1 } });
  const [firstColumnName, setFirstColumnName] = useState("کالا");
  const [tableData, setTableData] = useState([]);
  const [marketerList, setMarketerList] = useState([]);
  const [selectedMarketer, setSelectedMarketer] = useState(0);

  const startDate = useRef(null);
  const endDate = useRef(null);
  useEffect(() => {
    getAllMarketers().then((i) => {
      if (i.success) {
        setMarketerList(i.data);
      } else {
        message.error(
          "مشکلی هنگام دریافت اطلاعات بازاریاب ها به وجود آمد",
          3000
        );
      }
    });
  }, []);
  useEffect(() => {
    switch (tableType.target.value) {
      case 1:
        setFirstColumnName("کالا");
        break;
      case 2:
        setFirstColumnName("روز");
        break;
      case 3:
        setFirstColumnName("ماه");
        break;
      case 4:
        setFirstColumnName("شخص");
        break;
    }
  }, [tableType]);
  const columns = [
    {
      title: firstColumnName,
      dataIndex: "name",
      key: "name",
      search: true,
    },
    {
      title: "تعداد",
      dataIndex: "qty",
      key: "qty",
      search: true,
      sort: true,
      num: true,
    },
    {
      title: "قیمت",
      dataIndex: "price",
      key: "price",
      search: true,
      sort: true,
      num: true,
    },
  ];

  const tableTitles = [firstColumnName, "تعداد", "نماد"];

  const options = [
    { label: "کالا", value: 1 },
    { label: "روز", value: 2 },
    { label: "ماه", value: 3 },
    { label: "شخص", value: 4 },
  ];
  function onChangeHandler(v) {
    setTableType(v);
  }
  // function okHandler() {
  //   setLoadingButton(true);
  //   console.log("startDate", startDate.current);
  //   console.log("endDate", endDate.current);
  //   console.log("tableType", tableType.target.value);

  //   ReadReport({
  //     sDate: startDate.current,
  //     eDate: endDate.current,
  //     type: tableType.target.value,
  //     visitor: selectedMarketer,
  //   })
  //     .then((i) => {
  //       if (i.success) {
  //         setTableData(i.response);
  //       } else {
  //         setTableData([]);
  //         message.error(i.message);
  //       }
  //     })
  //     .finally(() => {
  //       setLoadingButton(false);
  //       setModalOpen(false)
  //     })
  //     .catch((e) => {
  //       setTableData([]);
  //       message.error("مشکلی هنگام انجام عملیات رخ داد"+ e);
  //     });
  // }
  function okHandler() {
    setLoadingButton(true);
  
    ReadReport({
      sDate: startDate.current,
      eDate: endDate.current,
      type: tableType.target.value,
      visitor: selectedMarketer,
    })
      .then((i) => {
        if (i.success) {
          setTableData(i.response);
        } else {
          setTableData([]);
          message.info(typeof i.message === "string" ? i.message : "داده ای در این بازه ثبت نشده است لطفا فیلتر خود را تغییر دهید.");
        }
      })
      .catch((e) => {
        const errorMessage = e.response?.data?.message || e.message || "مشکلی هنگام انجام عملیات رخ داد";
        setTableData([]);
        message.error(errorMessage);
      })
      .finally(() => {
        setLoadingButton(false);
        setModalOpen(false);
      });
  }
  return (
    <>
      <Modal
        open={opneModal}
        footer={[
          <Button
            key="submit"
            onClick={okHandler}
            loading={loadingButton}
            type="primary"
          >
            تایید
          </Button>,
          <Button
            key="cancel"
            disabled={loadingButton}
            onClick={() => {
              setModalOpen(false);
            }}
          >
            لغو
          </Button>,
        ]}
      >
        <Form>
          <Row className="box">
            <Col lg={6} md={12} sm={12}>
              <Form.Item label="از تاریخ" labelAlign="right">
                <PersianDatePicker ref={startDate} slash={true}/>
              </Form.Item>
            </Col>
            <Col lg={6} md={12} sm={12}>
              <Form.Item label="تا تاریخ">
                <PersianDatePicker ref={endDate}  slash={true}/>
              </Form.Item>
            </Col>
            <Col lg={6} md={12} sm={12}>
              <Form.Item label="نوع" labelAlign="right" name="type">
                <RadioGroup
                  options={options}
                  onChange={onChangeHandler}
                  defaultValue={1}
                />
              </Form.Item>
            </Col>
            <Col lg={24} md={24} sm={24}>
              <Form.Item label="بازاریاب" labelAlign="right">
                <Select onChange={setSelectedMarketer} defaultValue={0}>
                  <Select.Option value={0}>همه بازاریاب ها</Select.Option>
                  {marketerList.map((i) => (
                    <Select.Option value={i.code}>{i.name}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Row>
        <Button
          shape="circle"
          type="primary"
          onClick={() => {
            setModalOpen(true);
          }}
          icon={<i className="fa fa-play" />}
        />{" "}
      </Row>
      {loadingButton ? (
        <CircularProgress />
      ) : tableData.length ? (
        <ListPage
          columns={columns}
          data={tableData}
          reloader={() => {}}
          tableTitles={tableTitles}
        />
      ) : (
        <Widget title="داده ای موجود نیست">
          لطفا تنظیمات گزارش خود را تغییر دهید
        </Widget>
      )}
    </>
  );
}
